module.exports = __webpack_public_path__ + "img/zsjm-4.aa8ee37f.webp";